import { isOpenInApp, stringToBoolean } from "@repo/shared-utils/pwa-utils";
import SectionHeaderLayout from "../../common/components/SectionHeaderLayout";
import RedirectionHandler from "../../common/handlers/RedirectionHandler";
import { getIPOListData } from "../../services/TradingMallService";
import FeatureItem from "./subComponent/FeatureItem";
import HideOnLogin from "../HideOnLogin/HideOnLogin";
import { IFeaturesContent } from "./types";
import { componentNameConstants } from "@repo/analytics/data-layer.constants";

const FeatureCarousel = async ({ content }: { content: IFeaturesContent }) => {
  const ipoData = await getIPOListData({ page: 1, limit: 5, ipoType: "current", subType: "all" });
  const { headerName, list } = content;
  const objValueList = Object.values(list);

  return (
    <SectionHeaderLayout header={headerName}>
      <div className={`flex flex-row gap-[16px] overflow-x-auto md:flex-wrap no-scrollbar`}>
        {
          objValueList?.map((el, idx) => {
            if (stringToBoolean(el.hideOnLogin)) {
              return (
                <HideOnLogin
                  key={el?.cardTitle}
                >
                  <RedirectionHandler
                    url={isOpenInApp() ? el.appdataurl : el.webdataurl}
                    cta_text={el?.cardTitle} section_title={componentNameConstants.FEATURES}
                    isLoginRequired={el?.isLoginRequired ?? "false"}
                  >
                    <FeatureItem url={isOpenInApp() ? el.mobileImage : el.desktopimage} title={el.cardTitle} nudge={el?.itemKey?.toLowerCase() === "ipo" ? ipoData?.data?.totalcount : null} />
                  </RedirectionHandler>
                </HideOnLogin>
              )
            }
            return (
              <RedirectionHandler
                url={isOpenInApp() ? el.appdataurl : el.webdataurl}
                key={el?.cardTitle} cta_text={el?.cardTitle} section_title={componentNameConstants.FEATURES}
                isLoginRequired={el?.isLoginRequired ?? "false"}
              >
                <FeatureItem url={isOpenInApp() ? el.mobileImage : el.desktopimage} title={el.cardTitle} nudge={el?.itemKey?.toLowerCase() === "ipo" ? ipoData?.data?.totalcount : null} />
              </RedirectionHandler>
            )

          })
        }
      </div>
    </SectionHeaderLayout>
  );
};

export default FeatureCarousel;